import { Box, Card, Grid, Icon, IconButton, InputLabel, MenuItem } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useState, useEffect } from "react";
import { post } from "utils/WebService";

export default function MarcacaoEspecialCreateEdit({ id, closeCreateEdit, dataOriginal }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    
    const [formData, setFormData] = useState({
        ccNome: "",
        cvAlvo: 3,
        cvAtivo: true
    });
    
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id && dataOriginal) {
            setFormData({
                ccNome: dataOriginal.ccNome,
                cvAlvo: dataOriginal.cvAlvo,
                cvAtivo: dataOriginal.cvAtivo
            });
        }
    }, [id, dataOriginal]);

    const handleSave = () => {
        if (!formData.ccNome) {
            alert("Nome é obrigatório");
            return;
        }
        setLoading(true);
        const req = id ? post(`/marcacoes/${id}`, formData) : post("/marcacoes", formData);
        
        req.then(() => {
            setLoading(false);
            closeCreateEdit();
        }).catch(() => {
            setLoading(false);
            alert("Erro ao salvar marcação");
        });
    };

    return (
        <Card id="marcacao-info">
            <Box display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h6">{id ? "Editar" : "Nova"} Marcação Especial</MDTypography>
            </Box>

            <MDBox px={3}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Nome da Marcação</InputLabel>
                        <MDInput
                            fullWidth
                            value={formData.ccNome}
                            onChange={(e) => setFormData({ ...formData, ccNome: e.target.value })}
                        />
                    </Grid>
                
                <Grid item xs={12} sm={3}>
                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Aplica-se a</InputLabel>
                    <MDInput
                        select
                        fullWidth
                        value={formData.cvAlvo}
                        onChange={(e) => setFormData({ ...formData, cvAlvo: e.target.value })}
                        InputProps={{
                            sx: { height: 44 }
                        }}
                    >
                        <MenuItem value={1}>Ficha (Devedor)</MenuItem>
                        <MenuItem value={2}>Contrato</MenuItem>
                        <MenuItem value={3}>Ambos</MenuItem>
                    </MDInput>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Status</InputLabel>
                    <MDInput
                        select
                        fullWidth
                        value={formData.cvAtivo}
                        onChange={(e) => setFormData({ ...formData, cvAtivo: e.target.value })}
                        InputProps={{
                            sx: { height: 44 }
                        }}
                    >
                        <MenuItem value={true}>Ativo</MenuItem>
                        <MenuItem value={false}>Inativo</MenuItem>
                    </MDInput>
                </Grid>
            </Grid>
            </MDBox>

            <Box display="flex" alignItems="center" justifyContent="end" p={3}>
                <MDButton color="light" onClick={closeCreateEdit} sx={{ mr: 2 }}>
                    Cancelar
                </MDButton>
                <MDButton color="info" onClick={handleSave} disabled={loading}>
                    Salvar
                </MDButton>
            </Box>
        </Card>
    );
}
